export default __webpack_public_path__ + "static/media/powerbanck.e87b9a37.png";